import Header, { HeaderProps } from './Header';

export default Header;
export type { HeaderProps };
